<template>
  <div class="qtt-token-container">
    <el-row :gutter="20" class="toolbar">
      <el-col :span="6">
        <el-input v-model="searchKeyword" placeholder="请输入管理账户id" clearable />
      </el-col>
      <el-col :span="6">
        <el-button type="primary" @click="handleSearch">查询</el-button>
        <el-button type="success" @click="handleAdd">添加</el-button>
      </el-col>
    </el-row>

    <el-table :data="tableData" border style="width: 100%; margin-top: 20px">
      <el-table-column prop="id" label="ID" width="80" />
      <el-table-column prop="uname" label="管理账户id" />
      <el-table-column prop="utoken" label="账户Token" />
      <el-table-column prop="rfstoken" label="刷新Token" />
      <el-table-column prop="cilentid" label="应用ID" />
      <el-table-column label="操作" width="180">
        <template slot-scope="scope">
          <el-button type="primary" size="mini" @click="handleEdit(scope.row)">编辑</el-button>
          <el-button type="danger" size="mini" @click="handleDelete(scope.row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 添加/编辑弹窗 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible">
      <el-form :model="form" label-width="100px">
        <el-form-item label="管理账户id">
          <el-input v-model="form.uname" />
        </el-form-item>
        <el-form-item label="账户Token">
          <el-input v-model="form.utoken" />
        </el-form-item>
        <el-form-item label="刷新Token">
          <el-input v-model="form.rfstoken" />
        </el-form-item>
        <el-form-item label="应用ID">
          <el-input v-model="form.cilentid" />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitForm">确认</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'QttTokenManager',
  data() {
    return {
      userId: this.$route.query.userId || null,
      searchKeyword: '',
      tableData: [],
      dialogVisible: false,
      dialogTitle: '',
      form: {
        id: null,
        uname: '',
        utoken: '',
        rfstoken: '',
        cilentid: ''
      }
    };
  },
  created() {
    this.fetchAll();
  },
  methods: {
    fetchAll() {
      console.log(this.userId)
      axios.get('https://control.zjwec.cn/api/qtttoken/list', {
        params: {
          uid: this.userId
        }
      }).then(res => {
        this.tableData = res.data;
      });
    },
    handleSearch() {
      if (!this.searchKeyword) {
        return this.fetchAll();
      }

      axios.get('https://control.zjwec.cn/api/qtttoken/getByKhname', {
        params: {
          keyword: this.searchKeyword,
          uid: this.userId
        }
      }).then(res => {
        this.tableData = res.data;
      });
    },
    handleAdd() {
      this.dialogTitle = '添加Token';
      this.form = {
        uname: '',
        utoken: '',
        rfstoken: '',
        cilentid: '',
        uid: this.userId
      };
      this.dialogVisible = true;
    },
    handleEdit(row) {
      this.dialogTitle = '编辑Token';
      this.form = { ...row };
      this.dialogVisible = true;
    },
    handleDelete(id) {
      this.$confirm('确定删除该记录吗？', '提示', {
        type: 'warning'
      }).then(() => {
        axios.get(`https://control.zjwec.cn/api/qtttoken/delete?id=${id}`).then(() => {
          this.$message.success('删除成功');
          this.fetchAll();
        });
      });
    },
    submitForm() {
      if (this.form.id) {
        // 编辑
        axios.put(
          'https://control.zjwec.cn/api/qtttoken/update',
          this.form
        ).then(() => {
          this.$message.success('更新成功');
          this.dialogVisible = false;
          this.fetchAll();
        });
      } else {
        // 新增
        axios.post(
          'https://control.zjwec.cn/api/qtttoken/create',
          this.form
        ).then(() => {
          this.$message.success('创建成功');
          this.dialogVisible = false;
          this.fetchAll();
        });
      }
    }

  }
};
</script>

<style scoped>
.qtt-token-container {
  padding: 20px;
}
.toolbar {
  margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/login/qtttoken.vue